export default function copyTextToClipboard(text) {
  if (typeof navigator === 'undefined' || !navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
    throw Error(`utils: copyTextToClipboard: environment not supported`);
  }

  return navigator.clipboard.writeText(text).catch(err => {
    throw Error(`utils: copyTextToClipboard: ${err}`);
  });
}